'use client';

import unproxify from './unproxify.js';
import validateFunctions from './validators.js';

/*
 * Validate form value by user's rule
 * @param: {
 *    fieldValue: value of target field
 *    fieldRules: rules of target field
 *    isEnable: enable validate or not
 * }
 * @return {
 *    message: error message after validated
 * }
 * */
function getFieldValidatedMessage(_a) {
    var fieldValue = _a.fieldValue, fieldRules = _a.fieldRules, fieldWatch = _a.fieldWatch, isEnable = _a.isEnable;
    if (!isEnable) {
        return '';
    }
    var message = '';
    /*
     * Use the [].every trick to break when has the error message
     * so that, we must return false if has any error, otherwise return true to continue
     * */
    fieldRules.every(function (rule) {
        switch (rule.type) {
            case 'required': {
                var valid = validateFunctions.required(fieldValue);
                if (!valid) {
                    message = rule.msg;
                    return false;
                }
                return true;
            }
            case 'email': {
                if (fieldValue && !validateFunctions.validateEmail(fieldValue)) {
                    message = rule.msg;
                    return false;
                }
                return true;
            }
            case 'number': {
                if (fieldValue && !validateFunctions.validateNumber(fieldValue)) {
                    message = rule.msg;
                    return false;
                }
                return true;
            }
            case 'no-number-email': {
                if (fieldValue && validateFunctions.validateNoNumberAndEmail(fieldValue)) {
                    message = rule.msg;
                    return false;
                }
                return true;
            }
            case 'url': {
                if (fieldValue && !validateFunctions.validateUrl(fieldValue)) {
                    message = rule.msg;
                }
                return true;
            }
            case 'no-special-chars': {
                if (fieldValue && validateFunctions.validateNoSpecialChars(fieldValue)) {
                    message = rule.msg;
                    return false;
                }
                return true;
            }
            case 'no-special-chars-without-number': {
                if (fieldValue && validateFunctions.validateNoSpecialCharsWithoutNumber(fieldValue)) {
                    message = rule.msg;
                    return false;
                }
                return true;
            }
            case 'international-phone-number': {
                if (fieldValue &&
                    !fieldValue.includes('+84') &&
                    !validateFunctions.validateI11lPhoneNumber(fieldValue)) {
                    message = rule.msg;
                    return false;
                }
                return true;
            }
            case 'vn-phone-number': {
                if (fieldValue &&
                    fieldValue.includes('+84') &&
                    !validateFunctions.validateVietNamPhoneNumber(fieldValue)) {
                    message = rule.msg;
                    return false;
                }
                return true;
            }
            case 'no-special-chars-for-job-title': {
                if (fieldValue && validateFunctions.validateNoSpecialCharsForJobTitle(fieldValue)) {
                    message = rule.msg;
                    return false;
                }
                return true;
            }
            case 'custom': {
                var convertedFieldWatch = unproxify(fieldWatch);
                var convertedFieldValue = unproxify(fieldValue);
                if (typeof rule.validator === 'function' && !rule.validator(convertedFieldValue, convertedFieldWatch)) {
                    message = rule.msg;
                    return false;
                }
                return true;
            }
            default:
                return true;
        }
    });
    return message;
}

export { getFieldValidatedMessage as default };
//# sourceMappingURL=getFieldValidatedMessage.js.map
